import React from 'react';
import { Button } from '../ui/Button';
import { ChevronRight } from 'lucide-react';
export interface ProgramData {
  name: string;
  description: string;
  image?: string;
}
interface ProgramCardProps {
  program: ProgramData;
}
export function ProgramCard({
  program
}: ProgramCardProps) {
  return <div className="bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow overflow-hidden flex flex-col h-full" data-id="element-745">
      {/* Program Image */}
      {program.image && <div className="h-48 overflow-hidden" data-id="element-746">
          <img src={program.image} alt={program.name} className="w-full h-full object-cover object-center" data-id="element-747" />
        </div>}

      <div className="p-8 flex flex-col flex-grow" data-id="element-748">
        <div className="mb-6" data-id="element-749">
          <h3 className="text-2xl font-bold text-[#1a2332] mb-4" data-id="element-750">
            {program.name}
          </h3>
          <p className="text-slate-600 leading-relaxed" data-id="element-751">
            {program.description}
          </p>
        </div>

        <div className="mt-auto pt-6" data-id="element-752">
          <Button variant="outline" className="w-full border-[#1a2332] text-[#1a2332] hover:bg-[#1a2332] hover:text-white group" data-id="element-753">
            Learn More
            <ChevronRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-754" />
          </Button>
        </div>
      </div>
    </div>;
}